import P2Regular from 'components/typography/P2Regular';
import { FaultRow } from 'components/tables/data/fault/types';
import Excerpt from 'components/Excerpt';

/**
 * Column for the fault description.
 */
export default function DescriptionColumn({ data: { description = '' } }: { data: FaultRow }) {
  return (
    <P2Regular color="gray.8" lineClamp={3}>
      <Excerpt text={description} length={70} />
    </P2Regular>
  );
}
